import { loadNg1Module, ngmodule } from '../../bootstrap/ngmodule'
import { activateAccountState, loginState, newPasswordState, resetPasswordState } from './account.states'
import { umsWindowed } from './components/windowed/windowed.component'
import { activateAccountComponent } from './containers/activate/activate.component'
import { loginComponent } from './containers/login/login.component'
import { newPasswordComponent } from './containers/new-password/new-password.component'
import { resetPasswordComponent } from './containers/reset-password/reset-password.component'

const accountModule = {
  components: { loginComponent, resetPasswordComponent, newPasswordComponent, activateAccountComponent, umsWindowed },
  states: [loginState, resetPasswordState, newPasswordState, activateAccountState],
}

loadNg1Module(ngmodule, accountModule)



// WEBPACK FOOTER //
// ./app/account/account.module.js